import { render, staticRenderFns } from "./PembayaranBunga.vue?vue&type=template&id=0d83bf52"
import script from "./PembayaranBunga.vue?vue&type=script&lang=js"
export * from "./PembayaranBunga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports